import { Icon, Stack } from "@einride/ui"
import styled from "@emotion/styled"
import { motion } from "framer-motion"

export const StyledIcon = styled(Icon)`
  cursor: pointer;
  position: absolute;
  left: 0;
`
export const StickyStack = styled(Stack)`
  position: sticky;
  top: -1.5rem;
  background: ${({ theme }) => theme.colors.background.primary};
  padding-top: 1.5rem;
  z-index: 1;
`

export const Controls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media ${({ theme }) => theme.mediaQueries.belowMd} {
    margin-top: 1rem;
  }
`

export const Container = styled(motion.div)<{ visible: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 1rem 1.5rem 1rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
  ${({ visible }) => (!visible ? "display: none;" : "")}
`
